module.exports = __webpack_public_path__ + "static/media/section-4@2x.85878b6c.png";